import type { AllRouteEndpoints } from "../routeTypes";

/** Attaching or deleting a document changes the guideline's documents list, so refetch it. */
export const postGenerativeAiBrandGuidelineDocumentCacheKeys: AllRouteEndpoints[] = [
  "/generative_ai/brand_guideline",
];

export const deleteGenerativeAiBrandGuidelineDocumentCacheKeys: AllRouteEndpoints[] = [
  "/generative_ai/brand_guideline",
];
